import { Typography } from '@forgeglobal/design-framework';
import { useStyles } from './style';
import formatCurrency from '@tcs/common/utils/formatCurrency';

interface RealEstateValuationInfoCardProps {
  percentageShare: number;
  totalValue?: number;
}

export const RealEstateValuationInfoCard = ({
  percentageShare,
  totalValue,
}: RealEstateValuationInfoCardProps) => {
  const classes = useStyles();

  const ownershipAmount = totalValue * (percentageShare / 100);
  const formattedAmount = formatCurrency(
    Math.floor(ownershipAmount * 100) / 100
  );

  return (
    <>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.ownershipInfo}
        data-test-id="real-estate-ownership-info">
        Your ownership is valued at <strong>{formattedAmount}</strong>, based on
        your <strong>{percentageShare}%</strong> share of the total property
        value.
      </Typography>
    </>
  );
};
